module.exports = __webpack_public_path__ + "static/img/user1.461e26d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user1.jpg
// module id = 2g0f
// module chunks = 1